let addWatermark = async (imageUrl) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const image = new Image();
  image.src = imageUrl;
  image.crossOrigin = "anonymous";

  return await new Promise(resolve => {
    image.onload = () => {
      // 缩小图片尺寸为原来的一半
      // const targetWidth = image.width / 2;
      // const targetHeight = image.height / 2;

      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0);

      const watermarkText1 = "昌恩智能";
      const watermarkText2 = "www.szce.com";
      const fontSize = calculateFontSize(canvas.height);

      ctx.font = `${fontSize}px 'Microsoft YaHei'`;
      // ctx.fillStyle = "#dbdbdb";
      // ctx.fillStyle = "rgba(108, 106, 106 , 0.5)";
      ctx.fillStyle = "rgba(66,66,66, 0.5)";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      const rotationAngle = -6 * (Math.PI / 180);
      ctx.rotate(rotationAngle);

      // 垂直偏移值
      const yOffset = 70;
      console.log(" canvas.width", canvas.width);
      console.log(" canvas.height", canvas.height);

      if (canvas.width > 6000 && canvas.height < 4400) {
        console.log('canvas.width > 6000 && canvas.width < 4400');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 10; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "140px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height / 10) + canvas.height / 24 + yOffset;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 10) +
              (canvas.height / 24) * 1.8 +
              yOffset;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      }
      else if(canvas.width > 6000){
        console.log('canvas.width > 6000');
          // 使用嵌套循环绘制水印
          for (let row = 0; row < 14; row++) {
            for (let col = 0; col < 5; col++) {
              ctx.font = "140px 'Microsoft YaHei'";
              const x = col * (canvas.width / 5) + canvas.width / 10;
              const y =
                row * (canvas.height / 14) + canvas.height / 24 + yOffset;
              ctx.fillText(watermarkText1, x, y);
  
              const x2 = col * (canvas.width / 5) + canvas.width / 10;
              const y2 =
                row * (canvas.height / 14) +
                (canvas.height / 24) * 1.6 +
                yOffset;
              ctx.fillText(watermarkText2, x2, y2);
            }
          }
      }
      else if(canvas.width > 2820) {
        console.log('Canvas.width > 2820');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 10; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "62px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height / 10) + canvas.height / 24 + yOffset;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 10) +
              (canvas.height / 24) * 1.6 +
              yOffset;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      }
      else if (canvas.width > 1000 && canvas.height < 800) {
        console.log('Canvas.width > 1000 && canvas.height < 800');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 10; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "20px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height / 10) + canvas.height / 24 + yOffset;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 10) +
              (canvas.height / 24) * 1.6 +
              yOffset;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      } 
      else if (canvas.width > 1000) {
        console.log('Canvas.width > 1000');

        // 使用嵌套循环绘制水印
        for (let row = 0; row < 10; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "26px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height / 10) + canvas.height / 24 + yOffset;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 10) +
              (canvas.height / 24) * 1.6 +
              yOffset;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      } 
      else if (canvas.width > 800) {
        console.log('Canvas.width > 800');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 10; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "18px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height / 10) + canvas.height / 24 + yOffset;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 10) +
              (canvas.height / 24) * 1.6 +
              yOffset;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      } 
      else if (canvas.width >599 && canvas.height <300) {
        console.log('Canvas.width > 600 && canvas.height <300');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 8; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "10px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height / 8) + canvas.height / 24 + yOffset;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 8) +
              (canvas.height / 24) * 1.8 +
              yOffset;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      } 
      else if (canvas.width >599 && canvas.height <900) {
        console.log('Canvas.width > 600 && canvas.height <900');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 12; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "10px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height / 12) + canvas.height / 24 + yOffset;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 12) +
              (canvas.height / 24) * 1.6 +
              yOffset;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      } 
      
      else if (canvas.width >599) {
        console.log('Canvas.width > 600');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 10; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "12px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height / 10) + canvas.height / 24 + yOffset;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 10) +
              (canvas.height / 24) * 1.6 +
              yOffset;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      } 
      else if (canvas.width > 500 && canvas.height >450) {
        console.log('Canvas.width > 500 && canvas.height >450');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 8; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "10px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height /8) + canvas.height / 24 + 20;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 8) +
              (canvas.height / 24) * 1.6 + 20;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      } 
      else if (canvas.width > 500 && canvas.height >200) {
        console.log('Canvas.width > 500 && canvas.height >200');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 6; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "10px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height /6) + canvas.height / 24 + 20;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 6) +
              (canvas.height / 24) * 1.6 + 24;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      } 
      else if (canvas.width > 500) {
        console.log('Canvas.width > 500');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 10; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "10px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height / 10) + canvas.height / 24 + 20;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 10) +
              (canvas.height / 24) * 1.6 + 20;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      } 
      else if (canvas.width > 400 && canvas.height > 300) {
        console.log('Canvas.width > 400 && canvas.height > 300');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 8; row++) {
          for (let col = 0; col < 4; col++) {
            ctx.font = "8px 'Microsoft YaHei'";
            const x = col * (canvas.width / 4) + canvas.width / 10;
            const y =
              row * (canvas.height / 8) + canvas.height / 24 + 20;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 4) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 8) +
              (canvas.height / 24) * 1.6 + 22;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      }
      else if (canvas.width > 400 &&canvas.height<300) {
        console.log('Canvas.width > 400 && canvas.height < 300');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 8; row++) {
          for (let col = 0; col < 4; col++) {
            ctx.font = "8px 'Microsoft YaHei'";
            const x = col * (canvas.width / 4) + canvas.width / 10;
            const y =
              row * (canvas.height / 8) + canvas.height / 24 + 20;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 4) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 8) +
              (canvas.height / 24) * 1.6 + 22;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      }
      else if (canvas.width > 400) {
        console.log('Canvas.width > 400?');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 10; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "10px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height / 10) + canvas.height / 24 + 20;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 10) +
              (canvas.height / 24) * 1.6 + 20;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      }
      else if (canvas.width > 300 && canvas.height>500) {
        console.log('Canvas.width > 300 && canvas.height>500');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 10; row++) {
          for (let col = 0; col < 4; col++) {
            ctx.font = "8px 'Microsoft YaHei'";
            const x = col * (canvas.width / 4) + canvas.width / 10;
            const y =
              row * (canvas.height / 10) + canvas.height / 24 + 20;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 4) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 10) +
              (canvas.height / 24) * 1.6 + 22;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      } 
      else if (canvas.width > 200 && canvas.height<200) {
        console.log('Canvas.width > 200 && canvas.height<200');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 4; row++) {
          for (let col = 0; col < 4; col++) {
            ctx.font = "8px 'Microsoft YaHei'";
            const x = col * (canvas.width / 4) + canvas.width / 10;
            const y =
              row * (canvas.height / 4) + canvas.height / 24 + 20;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 4) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 4) +
              (canvas.height / 24) * 1.6 + 24;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      } 
      else if (canvas.width > 300) {
        console.log('Canvas.width > 300');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 8; row++) {
          for (let col = 0; col < 3; col++) {
            ctx.font = "8px 'Microsoft YaHei'";
            const x = col * (canvas.width / 3) + canvas.width / 10;
            const y =
              row * (canvas.height / 8) + canvas.height / 24 + 20;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 3) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 8) +
              (canvas.height / 24) * 1.6 + 22;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      }  
      else if (canvas.width > 100) {
        console.log('Canvas.width > 100');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 8; row++) {
          for (let col = 0; col < 3; col++) {
            ctx.font = "4px 'Microsoft YaHei'";
            const x = col * (canvas.width / 3) + canvas.width / 10;
            const y =
              row * (canvas.height / 8) + canvas.height / 24 + 20;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 3) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 8) +
              (canvas.height / 24) * 1.6 + 22;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      }  
      else {
        console.log('OTHER');
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 8; row++) {
          for (let col = 0; col < 3; col++) {
            ctx.font = "8px 'Microsoft YaHei'";
            const x = col * (canvas.width / 3) + canvas.width / 10;
            const y =
              row * (canvas.height / 8) + canvas.height / 24 + 20;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 3) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 8) +
              (canvas.height / 24) * 2 +
              20;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      }

      // 恢复Canvas的旋转状态
      ctx.rotate(-rotationAngle);
      let watermarkedImageUrl
      if (canvas.width > 6000) {
       watermarkedImageUrl = canvas.toDataURL("image/jpeg", 0.8);
      //  console.log('图片大于6000');
      }
      else if (canvas.width > 2000) {
        watermarkedImageUrl = canvas.toDataURL("image/jpeg", 0.8);
       //  console.log('图片大于6000');
       }
      else{
        watermarkedImageUrl = canvas.toDataURL("image/jpeg",1);
      }
      // this.watermarkedImages = watermarkedImageUrl;
      resolve(watermarkedImageUrl);
    };
  });
}

function calculateFontSize(canvasHeight) {
  // 根据 canvas 的高度动态计算字体大小
  return Math.floor(canvasHeight / 64);
}


// export async function addWatermarkToData(data, vm) {
//   let num = data.length
//   vm.watermarkedImageList = [];
//   for (const item of data) {
//     const imageUrl = item.imgPath;
//     // const watermarkedImageUrl = await addWatermark(imageUrl); // 使用水印方法
//     let watermarkedImageUrl
//     if (imageUrl) {
//       watermarkedImageUrl = await addWatermark(imageUrl); // 使用水印方法
//     }

//     const watermarkedData = {
//       imgPath: watermarkedImageUrl,
//       resourceId: item.resourceId,
//       title: item.title,
//       sort: item.sort
//     };
//     // console.log("watermarkedData", watermarkedData);
//     vm.watermarkedImageList.push(watermarkedData);
//     num--
//   }
//   if (num <= 0) {
//     // console.log('数据加载完成');
//     vm.isLoading = true;
//   }
//   return vm.watermarkedImageList;
// };

export async function addWatermarkToData(data, vm) {
  let num = data.length
  vm.watermarkedImageList = [];
  for (const item of data) {
    const imageUrl = item.imgPath;
    let watermarkedImageUrl='';
    try {
      if (imageUrl) {
        console.log('传入了图片',imageUrl);
        watermarkedImageUrl = await addWatermark(imageUrl); // 使用水印方法
      }
    } catch (error) {
      console.error("Error adding watermark to image:", error);
    }

    const watermarkedData = {
      imgPath: watermarkedImageUrl,
      resourceId: item.resourceId,
      title: item.title,
      sort: item.sort
    };
    vm.watermarkedImageList.push(watermarkedData);
    num--;
  }
  if (num <= 0) {
    vm.isLoading = true;
  }
  return vm.watermarkedImageList;
};



// WEBPACK FOOTER //
// ./src/utils/watermark.js